import { useState, useCallback, useRef, useEffect } from 'react';

/**
 * Detects whether a DOM element's text is overflowing (truncated).
 * Works with both single-line (noWrap/ellipsis) and multi-line (line-clamp) truncation.
 * Returns [ref, isOverflowing] — attach ref to the Typography element.
 */
const useIsOverflowing = () => {
  const ref = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const check = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setIsOverflowing(el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight);
  }, []);

  useEffect(() => {
    check();
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(check);
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [check]);

  return [ref, isOverflowing];
};

export default useIsOverflowing;
